"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function fetchBlob(file) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof file === "string")) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch(file).then(function (response) { return response.blob(); })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/, file];
            }
        });
    });
}
exports.fetchBlob = fetchBlob;
//# sourceMappingURL=utils.js.map